// .components/DangerZone
import PropTypes from 'prop-types';

const DangerZone = ({ onDelete, onCancel, showConfirm, onShowConfirm, loading }) => (
  <div className="panel surface-pad-normal">
    <div className="block">
      <div className="block__header">
        <div className="text-block-title">Danger Zone</div>
      </div>
      <div className="block__body">
        {!showConfirm ? (
          <button className="btn btn-outline" onClick={onShowConfirm}>
            Delete Account
          </button>
        ) : (
          <div className="stack stack-normal">
            <div className="text-body">
              Are you sure you want to delete your account? This action cannot be undone.
            </div>
            <div className="cluster cluster-normal">
              <button className="btn btn-ghost" onClick={onCancel}>
                Cancel
              </button>
              <button className="btn btn-solid" onClick={onDelete} disabled={loading}>
                Yes, Delete My Account
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  </div>
);

DangerZone.propTypes = {
  onDelete: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onShowConfirm: PropTypes.func.isRequired,
  showConfirm: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
};

export default DangerZone;